// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_5NT","cls2":"UpsellModalRedesign-cls2_7u_ UpsellModalRedesign-cls1_5NT","strikethrough":"UpsellModalRedesign-strikethrough_hZL"};